import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageBundle } from '@amzn/arb-tools';
import ColumnLayout from '@amzn/awsui-components-core/column-layout';
import Header from '@amzn/awsui-components-core/header';
import SpaceBetween from '@amzn/awsui-components-core/space-between';
import CampaignCard from 'src/components/molecules/CampaignCard';
import { t } from 'src/utils/helpers';

export interface CampaignTypeConfig {
  titleKey: string;
  descriptionKey: string;
  createRoute: string;
  viewRoute: string;
}

const CREATE_BUTTON_KEY = 'create_button';
const VIEW_BUTTON_KEY = 'view_button';

interface CampaignCardGridProps {
  bundle: MessageBundle | undefined;
  campaignTypes: CampaignTypeConfig[];
  headerKey: string;
}

const CampaignCardGrid: FC<CampaignCardGridProps> = ({
  bundle,
  campaignTypes,
  headerKey,
}) => {
  const navigate = useNavigate();

  return (
    <SpaceBetween size="l">
      <Header variant="h2">{t(bundle, headerKey)}</Header>
      <ColumnLayout columns={2}>
        {campaignTypes.map((campaign) => (
          <CampaignCard
            key={campaign.titleKey}
            title={t(bundle, campaign.titleKey)}
            description={t(bundle, campaign.descriptionKey)}
            createLabel={t(bundle, CREATE_BUTTON_KEY)}
            viewLabel={t(bundle, VIEW_BUTTON_KEY)}
            onCreateClick={() => navigate(campaign.createRoute)}
            onViewClick={() => navigate(campaign.viewRoute)}
          />
        ))}
      </ColumnLayout>
    </SpaceBetween>
  );
};

export default CampaignCardGrid;

